import React, {Component} from 'react';
import PropTypes from 'prop-types';
import translate from '../service/translation';

class RenderedItemsList extends Component {

    static propTypes = {
        renderedItems: PropTypes.array,
        detailViewUrl: PropTypes.string,
        EXTKEY: PropTypes.string
    };

    render() {
        const {renderedItems, detailViewUrl, EXTKEY} = this.props;

        return (
            <div className={EXTKEY + '__wrapper--events row'}>
                {renderedItems.length > 0 ? renderedItems.map(
                    item => <a className={EXTKEY + '__wrapper--event-link col-12 col-md-6 col-lg-4'} key={item.uid} href={detailViewUrl + item.slug}><div className={EXTKEY + '__event--item'} key={item.uid} dangerouslySetInnerHTML={{__html: item.renderedEvent}} /></a>
                ) : translate('list_no_results')}
            </div>
        );
    }
}

export default RenderedItemsList;



// WEBPACK FOOTER //
// ./React/src/components/RenderedItemsList.js